import Label from "./label.jsx";
import QuillEditor from "./quill-editor.jsx";

export default ({ label, value, naked, style, onChange, ...rest }) => {
  return (
    <div className={naked ? "naked-quill-editor" : ""} style={style}>
      {label && <Label>{label}</Label>}
      <QuillEditor value={value} onChange={onChange} basic={true} {...rest} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/partials/basic-html-field.jsx